module.exports = {"211404001":"赵家屯街道","211404002":"沙锅屯街道","211404003":"邱皮沟街道","211404005":"苇子沟街道","211404006":"三家子街道","211404007":"小凌河街道","211404008":"九龙街道","211404009":"龙飞街道","211404010":"龙腾街道","211404011":"龙翔街道","211404101":"缸窑岭镇","211404102":"暖池塘镇","211404103":"高桥镇","211404104":"虹螺岘镇","211404105":"金星镇","211404106":"台集屯镇","211404201":"沙锅屯乡","211404203":"黄土坎乡","211404204":"大兴乡","211404205":"张相公屯乡","211404400":"乌金塘水库"}


//////////////////
// WEBPACK FOOTER
// ./src/town/211404.json
// module id = 599
// module chunks = 0